import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '../loader/loader.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { IPolicy } from '../_models/compliance';
import { AuthenticationService } from './authentication.service';
import { User } from '../_models';
import { AppConfig } from 'src/assets/config/config/app-config';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class PolicyService {
  newPolicy: IPolicy
  apiUrl:string

  constructor(
    private http: HttpClient,
    private config:AppConfig
    //private authenticationService: AuthenticationService,
    //private messageService: MessageService,
    // private snackBar: MatSnackBar,
    // private loader: LoaderService
  ) {
    //this.currentUser = this.authenticationService.currentUserValue;
    this.apiUrl=this.config.getConfig("apiUrl")
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error)
  }

  get(policyId): Observable<any> {
    return this.http.get<any>(this.apiUrl+`/compliance/policies/get/` + policyId)
  }
  getPolicy() {
    return this.http.get<any>(this.apiUrl+`/compliance/policies`)
  }

  createPolicy(policyData) {
    if (policyData.type == "Duration") {
      policyData.date = ""
    }
    if (policyData.type == "Fixed") {
      policyData.duration.years = 0,
        policyData.duration.months = 0,
        policyData.duration.days = 0
    }
    this.newPolicy = policyData
    this.newPolicy.duration.years = parseInt(policyData.duration.years)
    this.newPolicy.duration.months = parseInt(policyData.duration.months)
    this.newPolicy.duration.days = parseInt(policyData.duration.days)
    return this.http.post<any>(this.apiUrl+`/compliance/policies/create`, this.newPolicy)
      .pipe(catchError(this.errorHandler))
  }

  updatePolicy(policyData) {
    if (policyData.type == "Duration") {
      var updatePolicyBody = {
        Id: policyData.Id,
        name: policyData.name,
        type: policyData.type,
        jurisdiction: policyData.jurisdiction,
        description: policyData.description,
        duration: {
          years: parseInt(policyData.duration.years),
          months: parseInt(policyData.duration.months),
          days: parseInt(policyData.duration.days)
        }
      }
      //console.log(updatePolicyBody)
      return this.http.put<any>(this.apiUrl+`/compliance/policies/update`, updatePolicyBody)
        .pipe(catchError(this.errorHandler))
    }
    if (policyData.type == "Fixed") {
      var updatePolicyBody2 = {
        Id: policyData.Id,
        name: policyData.name,
        type: policyData.type,
        jurisdiction: policyData.jurisdiction,
        description: policyData.description,
        date: policyData.date,
      }
      //console.log(updatePolicyBody2)
      return this.http.put<any>(this.apiUrl+`/compliance/policies/update`, updatePolicyBody2)
        .pipe(catchError(this.errorHandler))
    }
  }
}